export default function ProductsController() {
  const vm = this;

  vm.handleDeletedProduct = _handleDeletedProduct;

  function _handleDeletedProduct(product) {
    vm.products.splice(vm.products.indexOf(product), 1);
    vm.vendor.hasProducts = vm.products.length > 0;
    // NOTE: we do not need to sort after a delete
  }
}

ProductsController.$inject = [];
